export enum Category {
    TarifaBase,                // $ Tarifa Base
    DistanciaBase,             // km Distancia Base
    TarifaPorKmExtra,          // $ Tarifa por km extra
    DescuentoIdaVuelta,        // % Descuento Ida y Vuelta
    TarifaEsperaCada10Min,     // $ Tarifa de Espera (cada 10 min)
    CargoSobredimension,       // $ Cargo por Sobredimensión
    RecargoLluviaBase,         // $ Recargo por Lluvia (base)
    RecargoLluviaPorKm,        // $ Recargo por Lluvia (por km)
    ComisionPorPago,           // % Comisión por Pago
    FeriadoComun,              // % Recargo por Feriado Común
    FeriadoEspecial,           // % Recargo por Feriado Especial
    RecargoFueraDeCiudad,      // % Recargo por ser Fuera de la Ciudad
    IVA                        // % IVA
}
